var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDropArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 120,
    viewBox: "0 0 197 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    width: 152,
    height: 120,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_524_202652)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16,
    width: 152,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8333 24C37.3 24 38.5 25.2 38.5 26.6667V45.3333C38.5 46.8 37.3 48 35.8333 48H17.1667C15.7 48 14.5 46.8 14.5 45.3333V26.6667C14.5 25.2 15.7 24 17.1667 24H35.8333ZM19.8333 44V41.3333H17.1667V44H19.8333ZM19.8333 37.3333V34.6667H17.1667V37.3333H19.8333ZM19.8333 30.6667V28H17.1667V30.6667H19.8333ZM35.8333 44V41.3333H33.1667V44H35.8333ZM35.8333 37.3333V34.6667H33.1667V37.3333H35.8333ZM35.8333 30.6667V28H33.1667V30.6667H35.8333Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 28,
    width: 104,
    height: 6,
    rx: 3,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 38,
    width: 104,
    height: 6,
    rx: 3,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_524_202652)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 64,
    width: 152,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8333 72C69.3 72 70.5 73.2 70.5 74.6667V93.3333C70.5 94.8 69.3 96 67.8333 96H49.1667C47.7 96 46.5 94.8 46.5 93.3333V74.6667C46.5 73.2 47.7 72 49.1667 72H67.8333ZM51.8333 92V89.3333H49.1667V92H51.8333ZM51.8333 85.3333V82.6667H49.1667V85.3333H51.8333ZM51.8333 78.6667V76H49.1667V78.6667H51.8333ZM67.8333 92V89.3333H65.1667V92H67.8333ZM67.8333 85.3333V82.6667H65.1667V85.3333H67.8333ZM67.8333 78.6667V76H65.1667V78.6667H67.8333Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 76,
    width: 104,
    height: 6,
    rx: 3,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 86,
    width: 104,
    height: 6,
    rx: 3,
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_524_202652",
    x: 0.5,
    y: 16,
    width: 164,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_524_202652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_524_202652",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_524_202652",
    x: 32.5,
    y: 64,
    width: 164,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_524_202652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_524_202652",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDropArea);
export default __webpack_public_path__ + "static/media/upload-drop-area.c067428d5847067fc55d4354eb8ba7ca.svg";
export { ForwardRef as ReactComponent };